import React from 'react'
import Chatdetails from './Chatdetails'

const Projectdetails = ({taskdetails}) => {
  return (
        <div className='project-left-detail'>
            <span>Collaborators</span>
            <div className='left-bottom-chat'>
                {taskdetails[0].participants.map((item, index)=>(
                    <Chatdetails key={index} name={item.name} url={item.imgurl} livestate={item.livestatus}/>
                ))}
            </div>
        </div>
   
  )
}

export default Projectdetails